import apiClient from '../apiClient';

export const getRoles = () => {
  return apiClient.get('/roles');
};

export const getRole = (id) => {
  return apiClient.get(`/roles/${id}`);
};

export const createRole = (roleData) => {
  return apiClient.post('/roles', roleData);
};

export const updateRole = (id, roleData) => {
  return apiClient.put(`/roles/${id}`, roleData);
};

export const deleteRole = (id) => {
  return apiClient.delete(`/roles/${id}`);
};

export const getRolePermissions = (roleId) => {
  return apiClient.get(`/roles/${roleId}/permissions`);
};

export const assignPermissionToRole = (roleId, permissionId) => {
  return apiClient.post(`/roles/${roleId}/permissions/${permissionId}`);
};

export const removePermissionFromRole = (roleId, permissionId) => {
  return apiClient.delete(`/roles/${roleId}/permissions/${permissionId}`);
};